import React, { Component } from 'react';
import cx from 'classnames';
import _memoize from 'lodash.memoize';

import FiltersGroupContainer from './FiltersGroupContainer';
import FiltersGroupLabel from './FiltersGroupItemLabel';

import RadioButton from '../../RadioButtons/components/RadioButton';
import Icon from '../../Icon';
import Dropdown from '../../Dropdown';
import { getRadioChange, isRadioChecked } from '../helpers';
import DropdownFiltersGroupSelectedItem from './DropdownFiltersGroupSelectedItem';
import '../styles/_dropdownFilters.scss';








































function filterIsChecked({ selectedValues, value, shouldReturnOptionAllSelection, searchedItems }) {
  if (searchedItems.length > 0 && value === 'ALL') {return true;}

  return isRadioChecked(value, selectedValues, shouldReturnOptionAllSelection);
}

export default class MultiSearchFiltersGroup extends
Component {
  handleFilterChange = _memoize((
  { value }) =>
  () => {
    const { onChange, shouldReturnOptionAllSelection } = this.props;

    const changes = getRadioChange(
      value,
      shouldReturnOptionAllSelection
    );

    this.resetSearch();

    return onChange(changes);
  });

  static defaultProps = {
    selectedValues: [],
    filterFacets: []
  };

  constructor(props) {
    super(props);

    const initialSelectedValues = props.searchOptions.
    filter((filter) => props.selectedValues.includes(filter.value));

    this.state = {
      searchedItems: initialSelectedValues
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedValues } = this.props;
    const { searchedItems } = this.state;

    if (prevProps.selectedValues.length !== selectedValues.length && !selectedValues.length ||
    searchedItems.length > 0 && selectedValues.indexOf('ALL') < 0) {
      this.resetSearch();
    }
  }

  resetSearch = () => {
    this.setState({
      searchedItems: []
    });
  };

  handleSearchChange = (option) => {
    const { onChange } = this.props;
    const { searchedItems } = this.state;

    if (option && !searchedItems.find((item) => item.value === option.value)) {
      searchedItems.push(option);
    }

    this.setState({
      searchedItems
    });

    const searchedValues = searchedItems.map(({ value }) => value);

    return onChange(['ALL', ...searchedValues]);
  };

  onDeleteSearchedItem = (value) => {
    const { onChange } = this.props;
    const { searchedItems } = this.state;

    const updatedItems = searchedItems.filter((item) => item.value !== value);

    this.setState({
      searchedItems: updatedItems
    });

    const updatedValues = updatedItems.map(({ value: updatedValue }) => updatedValue);

    return onChange(['ALL', ...updatedValues]);
  };

  render() {
    const {
      filterFacets = [],
      searchOptions,
      label: groupLabel,
      isCollapsible,
      openedByDefault,
      isSearchable = true,
      isClearable = true,
      placeholder,
      customPrefix,
      name,
      disabled,
      minWidth,
      loadOptions,
      searchPromptText,
      noResultsText,
      stats,
      selectedValues,
      shouldReturnOptionAllSelection
    } = this.props;

    const { searchedItems } = this.state;

    const decoratorToRender = typeof customPrefix === 'string' ?
    <Icon color="nevada" name={customPrefix} size={15} /> :
    customPrefix;

    return (
      <FiltersGroupContainer
        label={groupLabel}
        isCollapsible={isCollapsible}
        openedByDefault={openedByDefault}
        minWidth={minWidth}>

        {filterFacets.map(({ label, value, statKey }) =>
        <RadioButton
          key={value}
          value={value}
          disabled={disabled}
          selected={Boolean(filterIsChecked({
            selectedValues, value, shouldReturnOptionAllSelection, searchedItems
          }))}
          onChange={this.handleFilterChange({ value })}>

            <FiltersGroupLabel
            label={label || ''}
            stats={stats}
            statKey={statKey} />

          </RadioButton>
        )}
        {selectedValues.indexOf('ALL') >= 0 &&
        <div className={cx('dropdown-filter__wrapper', { 'dropdown-filter__wrapper-decorator': !!customPrefix })}>
            {decoratorToRender || ''}
            <Dropdown
            id={name}
            options={searchOptions}
            type="BUTTON"
            isSearchable={isSearchable}
            isClearable={isClearable}
            placeholder={placeholder}
            onChange={this.handleSearchChange}
            disabled={disabled}
            value={null}
            renderMenuLocally
            cutLongLabels
            loadOptions={loadOptions}
            searchPromptText={searchPromptText}
            noResultsText={noResultsText} />

            <div className="dropdown-selected-items">
              {
            searchedItems.map((item) =>
            <DropdownFiltersGroupSelectedItem
              key={item.value}
              value={item.value}
              label={item.label}
              icon={item.icon}
              iconColour={item.iconColour}
              iconBackground={item.iconBackground}
              imageUrl={item.imageUrl}
              placeholder={item.placeholder || item.label}
              circular={item.circular}
              onDelete={this.onDeleteSearchedItem} />

            )}

            </div>
          </div>}

      </FiltersGroupContainer>);

  }
}